import { Button } from "@/components/ui/primitives";
import { useI18n } from "@/i18n";

/**
 * The three states every list page shares, so no page invents its own
 * spinner-or-empty-or-error layout.
 */
export function DataState({
  isLoading,
  isError,
  isEmpty,
  onRetry,
  children,
}: {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  onRetry?: () => void;
  children: React.ReactNode;
}) {
  const { t } = useI18n();

  if (isLoading) {
    return <p className="py-12 text-center text-sm text-muted-foreground">{t("loading")}</p>;
  }

  if (isError) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-destructive">{t("error")}</p>
        {onRetry && (
          <Button variant="secondary" size="sm" className="mt-3" onClick={onRetry}>
            {t("retry")}
          </Button>
        )}
      </div>
    );
  }

  if (isEmpty) {
    return <p className="py-12 text-center text-sm text-muted-foreground">{t("empty")}</p>;
  }

  return <>{children}</>;
}
